// Live-refresh policy for Dashboard V2.
//
// The app-wide QueryClient (src/util/reactQueryClient.ts) is deliberately
// conservative — `staleTime: Infinity` with focus/reconnect refetching and
// retries all off. That suits the form-heavy pages it was written for, but it
// means a Dashboard V2 badge can never update without a full browser reload,
// and that the badge (whose hook lives at page level and never unmounts) drifts
// out of step with a queue list (whose hook remounts on every tab switch).
//
// These options are applied per Dashboard V2 query rather than by changing the
// shared client, so the dashboard polls and revalidates without altering
// behaviour on any other page.
export const DASHBOARD_REFRESH_MS = 30_000;

export const dashboardLiveQueryOptions = {
  staleTime: DASHBOARD_REFRESH_MS,
  refetchInterval: DASHBOARD_REFRESH_MS,
  // No polling while the tab is backgrounded; the focus refetch below covers
  // the return trip, so a hidden dashboard costs nothing.
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  // One retry so a single transient failure doesn't strand the tab on its
  // error state; the tabs also expose an explicit Retry action.
  retry: 1,
} as const;
